import { useState } from "react";

import { projects } from "../Data";

import { Row, Card, Badge } from "react-bootstrap";
import { FaGithub } from "react-icons/fa";
import { FaCode } from "react-icons/fa";

const Projects = () => {
    const [copied, setCopied] = useState("");

    const copyHandler = ({ name, short, about, tech }) => {
        setCopied(name);
        var s = short + "\n\n\u2022 "+about.join("\n\u2022 ")+"\n\nTechnology used : " + tech.join(" | ");

        navigator.clipboard.writeText(s);
        setTimeout(() => setCopied(""), 750);
    };

    return (
        <>
            {projects.map((proj) => (
                <Row key={proj.name} className="mb-3">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <b>{proj.name}</b>
                            <small>
                                {proj.repo && (
                                    <a
                                        href={proj.repo}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "purple" }}
                                    >
                                        <i>
                                            <b>
                                                Github <FaGithub />
                                            </b>
                                        </i>
                                    </a>
                                )}
                                {proj.deployed && (
                                    <a
                                        href={proj.deployed}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ms-3"
                                    >
                                        <i>
                                            <b>
                                                Deployed <FaCode />
                                            </b>
                                        </i>
                                    </a>
                                )}
                            </small>
                        </Card.Header>
                        <Card.Body>
                            <Card.Subtitle className="text-muted">
                                <ul>
                                    {proj.about.map((line) => (
                                        <li key={line}>{line}</li>
                                    ))}
                                </ul>
                            </Card.Subtitle>
                        </Card.Body>                        
                        <Card.Footer>
                            <div className="d-flex justify-content-between">
                                <div>
                                    {proj.tech &&
                                        proj.tech.map((skill) => (
                                            <Badge key={skill} className="me-2">
                                                {skill}
                                            </Badge>
                                        ))}
                                </div>
                                <small>
                                    <b>
                                        {copied === proj.name ? (
                                            "Copied"
                                        ) : (
                                            <i
                                                onClick={() =>
                                                    copyHandler({
                                                        name: proj.name,
                                                        short: proj.short,
                                                        about: proj.about,
                                                        tech: proj.tech,
                                                    })
                                                }
                                                style={{ cursor: "pointer" }}
                                            >
                                                <u>Copy</u>
                                            </i>
                                        )}
                                    </b>
                                </small>
                            </div>
                        </Card.Footer>
                    </Card>
                </Row>
            ))}
        </>
    );
};

export default Projects;
